var template = require('employee/templates/payslips/View.ejs');
var CommonPayslipView = require('commons/views/Payslip');

module.exports = Backbone.View.extend({
    payslipView: null,

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            payslip:         null,
            payslipDetails:  null,
            companyLocation: null,
            company: null
        });

        this.payslipView = new CommonPayslipView({
            model: this.options.payslip,
            payslipDetails: this.options.payslipDetails,
            companyLocation: this.options.companyLocation,
            company: this.options.company
        });

        return this.render();
    },

    render: function() {
        this.$el.html(template({}));

        this.$('.js-payslip').append(this.payslipView.el);

        return this;
    }
});



// WEBPACK FOOTER //
// ./app/employee/views/payslips/View.js